export const STORIES_ITEM_CONSTS = {
  archivateStory: 'Перенести сюжет в архив',
  deleteStory: 'Удалить сюжет',
  goToEditing: 'Перейти в редактирование сюжета',
  deleteItem: 'Удалить публикацию из сюжета',
  publicationsCount: 'Количество публикаций',
  viewsCount: 'Кол-во просмотров',
  unzipStory: 'Восстановить сюжет из архива',
  viewOnSite: 'Посмотреть сюжет на сайте',
  withoutName: 'Без названия'
}
